import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';
import { TokenCommonService } from '../token-common.service';
import { AuthService } from '../auth/auth.service';
import 'rxjs/add/operator/map';

@Injectable()
export class PreferencesService extends TokenCommonService {
  constructor(http: Http, authService: AuthService) {
    super(http, authService);
  }

  getByName(name: string) {
    // preferences endpoint is on a different (public) API; do not use token-authenticated helper
    return this.http.get(`${environment.SF_API_V2}/preferences/${name}`).map(res => res.json());
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/preferences/preferences.service.ts